import { useMemo } from 'react';
import { DataType } from '@vgtv/api-client/lib/component';

import { useAppSelector } from '../../modules/hooks';
import {
  selectAssetsForComponent,
  selectCategoriesForComponent,
  selectMixedForComponent,
} from '../../modules/components';
import { useVendor } from '../VendorPovider/VendorPovider';

import type {
  AssetCarouselComponent,
  CategoryCarouselComponent,
  MixedCarouselComponent,
} from '@vgtv/api-client/lib/component/carousel';
import type { RootState } from '../../modules/store';

export const useComponentItems = (
  componentConfig:
    | MixedCarouselComponent
    | AssetCarouselComponent
    | CategoryCarouselComponent
) => {
  const { data: { type: dataType } = {}, id } = componentConfig;

  const { vendor } = useVendor();

  let selector;

  if (dataType === DataType.ASSETS) {
    selector = (state: RootState) =>
      selectAssetsForComponent(state, vendor, id);
  } else if (dataType === DataType.CATEGORIES) {
    selector = (state: RootState) =>
      selectCategoriesForComponent(state, vendor, id);
  } else {
    selector = (state: RootState) => selectMixedForComponent(state, vendor, id);
  }

  const items = useAppSelector(selector);

  const foundItemsIds = items.map(({ id }) => id).join(',');
  return useMemo(() => items, [foundItemsIds]);
};
